import { Component } from '@angular/core';

@Component({
  selector: 'app-underconstruction',
  templateUrl: './underconstruction.component.html',
  styleUrl: './underconstruction.component.scss'
})
export class UnderconstructionComponent {

}
